import { JobOpeningStatus } from "@/types";

const jobStatusColorMap: Record<
  JobOpeningStatus,
  { dotColor: string; textColor: string; backgroundColor: string }
> = {
  "New Opening": {
    dotColor: "bg-red-600",
    backgroundColor: "bg-red-100",
    textColor: "text-red-600",
  },
  "Creating Job Spec": {
    dotColor: "bg-pink-600",
    backgroundColor: "bg-pink-100",
    textColor: "text-pink-600",
  },
  "Identifying Candidates": {
    dotColor: "bg-orange-600",
    backgroundColor: "bg-orange-100",
    textColor: "text-orange-600",
  },
  "Presenting Shortlist": {
    dotColor: "bg-violet-600",
    backgroundColor: "bg-blue-100",
    textColor: "text-blue-600",
  },
  "Role Filled (won)": {
    dotColor: "bg-violet-600",
    backgroundColor: "bg-violet-100",
    textColor: "text-violet-600",
  },
  "Role Filled (lost)": {
    dotColor: "bg-violet-600",
    backgroundColor: "bg-violet-100",
    textColor: "text-violet-600",
  },
};

const jobStatusToColors = (status?: JobOpeningStatus) =>
  jobStatusColorMap[status ?? "Role Filled (lost)"];

export default jobStatusToColors;
